import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, copyTextToClipboard, getPaymentProcessorTitle, toast, useTranslation as useUiTranslation } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { paystackDisconnect } from 'modules/profile/payment-gateways/integrations/paystack/api';
import PaystackCreateModal from 'modules/profile/payment-gateways/integrations/paystack/components/paystack-create-modal';
import { paystackPaymentProcessors } from 'modules/profile/payment-gateways/integrations/paystack/constants';
import { PaystackPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/paystack/types';
import { getPaystackHelpPageLink } from 'modules/profile/payment-gateways/integrations/paystack/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, CopyIcon, PaystackLogoIcon } from '@systemeio/ui/icons';
export const Paystack: FC = () => {
  const $ = _c(10);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== deleteOpened || $[1] !== getConnectedPaymentIntegration || $[2] !== removePaymentIntegration || $[3] !== t || $[4] !== tUi || $[5] !== user?.dashboardLocale) {
    const paystackIntegration = getConnectedPaymentIntegration({
      matcher: _temp
    });
    const title = getPaymentProcessorTitle(paystackIntegration ? paystackIntegration.paymentProcessor : PaymentProcessorEnum.PaystackEG, tUi);
    const onDelete = async () => {
      await paystackDisconnect();
      await removePaymentIntegration({
        matcher: _temp2
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PaystackLogoIcon />;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    const t2 = user?.dashboardLocale;
    let t3;
    if ($[8] !== t2) {
      t3 = getPaystackHelpPageLink(t2);
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t0 = <Integration logo={t1} additionalInfo={<a className="primary-link" href={t3} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
        integration: title
      }} /></a>}>{paystackIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!paystackIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}{paystackIntegration.details.webhookUrl && <div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.webhook_url")}:`}</span><span className="text-text-primary truncate">{paystackIntegration.details.webhookUrl}</span><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
                await copyTextToClipboard(paystackIntegration.details.webhookUrl || "", tUi);
              }} className="group outline-hidden"><CopyIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip></div>}</div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.paystack")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <PaystackCreateModal />}</Integration>;
    $[0] = deleteOpened;
    $[1] = getConnectedPaymentIntegration;
    $[2] = removePaymentIntegration;
    $[3] = t;
    $[4] = tUi;
    $[5] = user?.dashboardLocale;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
};
function _temp(paymentProcessor) {
  return paystackPaymentProcessors.includes(paymentProcessor);
}
function _temp2(paymentProcessor_0) {
  return paystackPaymentProcessors.includes(paymentProcessor_0);
}